<template lang="pug">
b-modal#editTriggerStatus(
  ref="editTriggerStatus"
  :title="$t('ui.combine.edit_trigger_status')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  :size="['CUSTOM_PROMO'].includes(action_type) ? 'xl' : 'lg'"
  @ok="done"
  @show="reset"
  @shown="shown"
  @cancel="cancelStatus"
  @close="cancelStatus"
  @hide="onClickEsc"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div.row
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.event_type')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="event_type"
            required
            type="text"
            :dirty="$v.event_type.$dirty"
            :error="$v.event_type.$error"
            v-model.trim.lazy="$v.event_type.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.event_type" :name="$t('ui.event_type')")
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.action_type')" v-if="event_type").mb-0
          TriggerActionLookup(
            ref="action_type"
            size="sm"
            required
            type="array"
            :dirty="$v.action_type.$dirty"
            :error="$v.action_type.$error"
            v-model.trim.lazy="$v.action_type.$model"
            :disabled="loading || event_type == 'PREDICT_CHURN'"
            :eventType="event_type"
          )
          ValidateResult(:value="$v.action_type" :name="$t('ui.action_type')")
    div.row
      div.col-sm-12.col-md-6.col-lg-6(v-if="['INBOX'].includes(action_type) || ['PREDICT_CHURN'].includes(event_type)")
        b-form-group(:label="$t('ui.campaign_id')").mb-0
          CampaignLookup(
            size="sm"
            ref="campaign_id"
            required
            type="array"
            :dirty="$v.campaign_id.$dirty"
            :error="$v.campaign_id.$error"
            v-model.trim.lazy="$v.campaign_id.$model"
            :disabled="loading"
            :operatorID="operatorID"
          )
          ValidateResult(:value="$v.campaign_id" :name="$t('ui.campaign_id')")
      div.col-sm-12.col-md-6.col-lg-6(v-if="['FREESPIN', 'INBOX'].includes(action_type)")
        b-form-group(:label="$t('ui.reward')").mb-0
          DebounceInput(
            size="sm"
            ref="promotion_id"
            required
            type="text"
            :dirty="$v.reward.$dirty"
            :error="$v.reward.$error"
            v-model.trim.lazy="$v.reward.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.reward" :name="$t('ui.reward')")
      div.col-sm-12.col-md-6.col-lg-6(v-if="['IDLE_USER', 'PREDICT_CHURN', 'WITHDRAWAL'].includes(event_type)")
        b-form-group(:label="$t('ui.threshold')").mb-0
          DebounceInput(
            size="sm"
            ref="promotion_id"
            required
            type="text"
            :dirty="$v.threshold.$dirty"
            :error="$v.threshold.$error"
            v-model.trim.lazy="$v.threshold.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.threshold" :name="$t('ui.threshold')")
    .row
      div.col-sm-12.col-md-3.col-lg-3
        b-form-group(:label="$t('ui.msg_greeting')").mb-2
          .d-flex
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="msg_greeting" :disable="loading")
              span.custom-switch-indicator
      div.col-sm-12.col-md-9.col-lg-9
        b-form-group(:label="$t('ui.msg_title')").mb-0
          DebounceInput(
            size="sm"
            ref="msg_title"
            required
            type="text"
            :dirty="$v.msg_title.$dirty"
            :error="$v.msg_title.$error"
            v-model.trim.lazy="$v.msg_title.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.msg_title" :name="$t('ui.title')")
    .row
      .col-12
        b-form-group(:label="$t('ui.msg_body')" :disable="loading").mb-3
          b-form-textarea(
            :dirty="$v.msg_body.$dirty"
            :error="$v.msg_body.$error"
            v-model.trim.lazy="$v.msg_body.$model"
            rows="3"
            max-rows="3"
            :disabled="loading"
            )
          ValidateResult(:value="$v.msg_body" :name="$t('ui.body')")
    template(v-if="['CUSTOM_PROMO'].includes(action_type)")
      .row
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.claim_type')").mb-0
            ClaimTypeLookup(
              ref="claim_type"
              size="sm"
              required
              type="array"
              :dirty="$v.claim_type.$dirty"
              :error="$v.claim_type.$error"
              v-model.trim.lazy="$v.claim_type.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.claim_type" :name="$t('ui.claim_type')")
        .col-sm-12.col-md-3.col-lg-3(v-if="!['ALL DAY','NEWBIE','ONCE','DAILY FIRST DEPOSIT'].includes(claim_type)")
          template(v-if="!['DAILY'].includes(claim_type)")
            b-form-group(:label="$t('ui.claim_limit')").mb-0
              b-form-select(
                size="sm"
                :dirty="$v.claim_limit.$dirty"
                :error="$v.claim_limit.$error"
                v-model.trim.lazy="$v.claim_limit.$model"
                :disabled="loading"
              )
                option(value=0) 0
                option(v-for="i in 10" :value="i") {{ i }}
              ValidateResult(:value="$v.claim_limit" :name="$t('ui.claim_limit')")
          template(v-else)
            b-form-group(:label="$t('ui.claim_limit')").mb-0
              DebounceInput(
                size="sm"
                ref="claim_limit_daily"
                required
                type="text"
                :dirty="$v.claim_limit_daily.$dirty"
                :error="$v.claim_limit_daily.$error"
                v-model.trim.lazy="$v.claim_limit_daily.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.claim_limit_daily" :name="$t('ui.claim_limit')")
        .col-sm-12.col-md-3.col-lg-3(v-if="!['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(claim_type)")
          b-form-group(:label="$t('ui.bonus_rate_percent')").mb-0
            DebounceInput(
              size="sm"
              ref="bonus_rate"
              required
              type="text"
              :dirty="$v.bonus_rate.$dirty"
              :error="$v.bonus_rate.$error"
              v-model.trim.lazy="$v.bonus_rate.$model"
              :disabled="loading"
            )
            span.small.text-info {{ $t("message.tooltips_promo_bonus_rate") }}
            ValidateResult(:value="$v.bonus_rate" :name="$t('ui.bonus_rate_percent')")
      .row(v-if="['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(claim_type) && claim_limit > 0 && claim_limit <= 10")
        .col-sm-12.col-md-12.col-lg-12
          b-form-group(:label="$tc('ui.bonus_rate', 2)")
            .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.mb-0(style="width: auto;")
                thead.thead-light
                  tr
                    th.text-center(v-for="x in Number(this.claim_limit)")
                      span {{ $t('ui.bonus_rate_' + x) }}
                tbody
                  tr
                    td(v-for="x in Number(this.claim_limit)")
                      div.d-flex.justify-content-center.align-items-center
                        DebounceInput.text-center(
                          size="sm"
                          :ref="'bonus_rate_' + x"
                          required
                          type="text"
                          :dirty="$v.formBonusRate['bonus_rate_' + x].$dirty"
                          :error="$v.formBonusRate['bonus_rate_' + x].$error"
                          v-model="formBonusRate['bonus_rate_' + x]"
                          :disabled="loading"
                        )
                      //- ValidateResult(:value="$v.formBonusRate['bonus_rate_' + x]" :name="$t('ui.bonus_rate_percent')")
              span.small.text-info {{ $t("message.tooltips_promo_bonus_rate") }}
      .row
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.deposit_amount')").mb-0
            DebounceInput(
              size="sm"
              ref="min_deposit"
              required
              type="text"
              :dirty="$v.min_deposit.$dirty"
              :error="$v.min_deposit.$error"
              v-model.trim.lazy="$v.min_deposit.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.min_deposit" :name="$t('ui.deposit_amount')")
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.max_bonus')").mb-0
            DebounceInput(
              size="sm"
              ref="max_bonus"
              required
              type="text"
              :dirty="$v.max_bonus.$dirty"
              :error="$v.max_bonus.$error"
              v-model.trim.lazy="$v.max_bonus.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.max_bonus" :name="$t('ui.max_bonus')")
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.rollover')").mb-0
            DebounceInput(
              size="sm"
              ref="rollover"
              type="text"
              :dirty="$v.rollover.$dirty"
              :error="$v.rollover.$error"
              v-model.trim.lazy="$v.rollover.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.rollover" :name="$t('ui.rollover')")
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.criteria')").mb-0
            VipCriteriaList(
              ref="criteria"
              size="sm"
              required
              type="array"
              :dirty="$v.criteria.$dirty"
              :error="$v.criteria.$error"
              v-model.trim.lazy="$v.criteria.$model"
              :disabled="loading"
              :hideOpt="hideOpt"
            )
            ValidateResult(:value="$v.criteria" :name="$t('ui.criteria')")
      .row
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.withhold_bonus')").mb-2
            div.d-flex
              label.custom-switch
                input.custom-switch-input(
                  type="checkbox"
                  required
                  :dirty="$v.withhold_bonus.$dirty"
                  :error="$v.withhold_bonus.$error"
                  v-model.trim.lazy="$v.withhold_bonus.$model"
                  :disabled="loading"
                )
                span.custom-switch-indicator
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.withhold_amount')").mb-0
            DebounceInput(
              size="sm"
              ref="withhold_amount"
              required
              type="text"
              :dirty="$v.withhold_amount.$dirty"
              :error="$v.withhold_amount.$error"
              v-model.trim.lazy="$v.withhold_amount.$model"
              :disabled="loading || withhold_bonus"
            )
            ValidateResult(:value="$v.withhold_amount" :name="$t('ui.withhold_amount')")
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.max_withdraw_amount')").mb-0
            DebounceInput(
              size="sm"
              ref="max_withdraw_amount"
              required
              type="text"
              :dirty="$v.max_withdraw_amount.$dirty"
              :error="$v.max_withdraw_amount.$error"
              v-model.trim.lazy="$v.max_withdraw_amount.$model"
              :disabled="loading || max_withdraw_multiple > 0"
              @input="inputMaxWithdraw($event, 'multiple')"
            )
            ValidateResult(:value="$v.max_withdraw_amount" :name="$t('ui.max_withdraw_amount')")
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.max_withdraw_multiple')").mb-0
            DebounceInput(
              size="sm"
              ref="max_withdraw_multiple"
              required
              type="text"
              :dirty="$v.max_withdraw_multiple.$dirty"
              :error="$v.max_withdraw_multiple.$error"
              v-model.trim.lazy="$v.max_withdraw_multiple.$model"
              :disabled="loading || max_withdraw_amount > 0"
              @input="inputMaxWithdraw($event, 'amount')"
            )
            ValidateResult(:value="$v.max_withdraw_multiple" :name="$t('ui.max_withdraw_multiple')")
      .row
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.start_date')").mb-0
            b-input-group(size="sm")
              date-picker.form-control-sm(
                ref="start_date"
                :config="localeDate"
                :dirty="$v.start_date.$dirty"
                :error="$v.start_date.$error"
                v-model.trim.lazy="$v.start_date.$model"
                :disabled="loading"
              )
            ValidateResult(:value="$v.start_date" :name="$t('ui.start_date')")
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.start_time')").mb-0
            b-input-group(size="sm")
              date-picker.form-control-sm(
                ref="start_time"
                :config="localeTime"
                :dirty="$v.start_time.$dirty"
                :error="$v.start_time.$error"
                v-model.trim.lazy="$v.start_time.$model"
                :disabled="loading"
              )
            ValidateResult(:value="$v.start_time" :name="$t('ui.start_time')")
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.end_date')").mb-0
            b-input-group(size="sm")
              date-picker.form-control-sm(
                ref="end_date"
                :config="localeDate"
                :dirty="$v.end_date.$dirty"
                :error="$v.end_date.$error"
                v-model.trim.lazy="$v.end_date.$model"
                :disabled="loading"
              )
            ValidateResult(:value="$v.end_date" :name="$t('ui.end_date')")
        .col-sm-12.col-md-3.col-lg-3
          b-form-group(:label="$t('ui.end_time')").mb-0
            b-input-group(size="sm")
              date-picker.form-control-sm(
                ref="end_time"
                :config="localeTime"
                :dirty="$v.end_time.$dirty"
                :error="$v.end_time.$error"
                v-model.trim.lazy="$v.end_time.$model"
                :disabled="loading"
              )
            ValidateResult(:value="$v.end_time" :name="$t('ui.end_time')")
      .row
        .col-sm-12.col-md-12.col-lg-12
          b-form-group(:label="$tc('ui.day', 2)")
            .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.w-100
                thead.thead-light
                  tr
                    th.text-center
                      span {{ $t('ui.monday') }}
                    th.text-center
                      span {{ $t('ui.tuesday') }}
                    th.text-center
                      span {{ $t('ui.wednesday') }}
                    th.text-center
                      span {{ $t('ui.thursday') }}
                    th.text-center
                      span {{ $t('ui.friday') }}
                    th.text-center
                      span {{ $t('ui.saturday') }}
                    th.text-center
                      span {{ $t('ui.sunday') }}
                tbody
                  tr
                    td
                      .d-flex.justify-content-center.align-items-center
                        label.custom-switch
                          input.custom-switch-input(
                            type="checkbox"
                            required
                            :dirty="$v.monday.$dirty"
                            :error="$v.monday.$error"
                            v-model.trim.lazy="$v.monday.$model"
                            :disabled="loading"
                          )
                          span.custom-switch-indicator
                      ValidateResult(:value="$v.monday" :name="$t('ui.monday')")
                    td
                      .d-flex.justify-content-center.align-items-center
                        label.custom-switch
                          input.custom-switch-input(
                            type="checkbox"
                            required
                            :dirty="$v.tuesday.$dirty"
                            :error="$v.tuesday.$error"
                            v-model.trim.lazy="$v.tuesday.$model"
                            :disabled="loading"
                          )
                          span.custom-switch-indicator
                      ValidateResult(:value="$v.tuesday" :name="$t('ui.tuesday')")
                    td
                      .d-flex.justify-content-center.align-items-center
                        label.custom-switch
                          input.custom-switch-input(
                            type="checkbox"
                            required
                            :dirty="$v.wednesday.$dirty"
                            :error="$v.wednesday.$error"
                            v-model.trim.lazy="$v.wednesday.$model"
                            :disabled="loading"
                          )
                          span.custom-switch-indicator
                      ValidateResult(:value="$v.wednesday" :name="$t('ui.wednesday')")
                    td
                      .d-flex.justify-content-center.align-items-center
                        label.custom-switch
                          input.custom-switch-input(
                            type="checkbox"
                            required
                            :dirty="$v.thursday.$dirty"
                            :error="$v.thursday.$error"
                            v-model.trim.lazy="$v.thursday.$model"
                            :disabled="loading"
                          )
                          span.custom-switch-indicator
                      ValidateResult(:value="$v.thursday" :name="$t('ui.thursday')")
                    td
                      .d-flex.justify-content-center.align-items-center
                        label.custom-switch
                          input.custom-switch-input(
                            type="checkbox"
                            required
                            :dirty="$v.friday.$dirty"
                            :error="$v.friday.$error"
                            v-model.trim.lazy="$v.friday.$model"
                            :disabled="loading"
                          )
                          span.custom-switch-indicator
                      ValidateResult(:value="$v.friday" :name="$t('ui.friday')")
                    td
                      .d-flex.justify-content-center.align-items-center
                        label.custom-switch
                          input.custom-switch-input(
                            type="checkbox"
                            required
                            :dirty="$v.saturday.$dirty"
                            :error="$v.saturday.$error"
                            v-model.trim.lazy="$v.saturday.$model"
                            :disabled="loading"
                          )
                          span.custom-switch-indicator
                      ValidateResult(:value="$v.saturday" :name="$t('ui.saturday')")
                    td
                      .d-flex.justify-content-center.align-items-center
                        label.custom-switch
                          input.custom-switch-input(
                            type="checkbox"
                            required
                            :dirty="$v.sunday.$dirty"
                            :error="$v.sunday.$error"
                            v-model.trim.lazy="$v.sunday.$model"
                            :disabled="loading"
                          )
                          span.custom-switch-indicator
                      ValidateResult(:value="$v.sunday" :name="$t('ui.sunday')")
      .row
        //- .col-sm-12.col-md-6.col-lg-3
        //-   b-form-group(:label="$t('ui.payment_option')" style="overflow: hidden scroll; height: 45vh;").mb-0
        //-     table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
        //-       thead.thead-light
        //-         tr
        //-           th.col-checkbox
        //-             b-form-checkbox(v-model="allSelectedPO" @change="selectAllPO")
        //-               span.font-weight-bold {{ allSelectedPO  ? $t('ui.unselect_all') : $t('ui.select_all') }}
        //-       tbody
        //-         tr(v-for='(p, index) in paymentOptionList')
        //-           td.col-checkbox
        //-             b-form-checkbox(v-model="payment_option_list" :value='p.value') {{ p.text }}
        //-   ValidateResult(:value="$v.payment_option_list" :name="$t('ui.payment_option')")
        //- .col-sm-12.col-md-9.col-lg-4
        //-   b-form-group(:label="$t('ui.payment_gateway')" style="overflow: hidden scroll; height: 45vh;").mb-0
        //-     table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
        //-       tr
        //-         th(colspan="3")
        //-           b-form-checkbox(v-model="allSelectedPG" @change="selectAllPG")
        //-             span.font-weight-bold {{ allSelectedPG  ? $t('ui.unselect_all') : $t('ui.select_all') }}
        //-       tr(v-for="(row, rowIndex) in rowsPGList" :key="rowIndex")
        //-         td(v-for='(p, itemIndex) in row' :key="itemIndex")
        //-           b-form-checkbox(v-model="payment_gateway_list" :value='p.value') {{ p.value }}
        //-   ValidateResult(:value="$v.payment_gateway_list" :name="$t('ui.payment_gateway_list')")
        div.col-sm-12.col-md-12.col-lg-12
          b-form-group(:label="$t('ui.provider_list')" style="overflow: hidden scroll; height: 45vh;").mb-0
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              tr
                th.text-center.col-checkbox.lb-provider(colspan=3)
                  .d-flex
                    .custom-checkbox.custom-control
                      input#all-provider.custom-control-input(type='checkbox' data-checkboxes="allSelected" data-checkbox-role="dad" @change="selectAll(0,$event)" v-model="allSelected[0]" :disabled="loading")
                      label.custom-control-label(for='all-provider') {{ $t('ui.all') }}
                    template(v-for="(cat, index) in providerCatList")
                      .custom-checkbox.custom-control
                        input.custom-control-input(
                          type="checkbox"
                          :id="'all-' + cat.toLowerCase()"
                          v-model="allSelected[index + 1]"
                          @change="selectAll(index + 1,$event)"
                          :disabled="loading"
                        )
                        label.custom-control-label(:for="'all-' + cat.toLowerCase()") {{ $t('ui.' + cat.toLowerCase()) }}
              tr(v-for="(row, rowIndex) in rowsPList" :key="rowIndex")
                td.col-checkbox.lb-provider(v-for='(p, itemIndex) in row' :key="itemIndex")
                  b-form-checkbox(v-model="provider_list" :value='p.value' :disabled="loading") {{ p.text }}

          ValidateResult(:value="$v.provider_list" :name="$t('ui.provider_list')")

  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, minLength, integer, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import VipCriteriaList from "@/library/VipCriteriaList";
import ClaimTypeLookup from "@/library/ClaimTypeLookup";
import PromotionType from "@/library/PromotionType";
import PromotionGroupLookup from "@/library/PromotionGroupLookup";
import BankProviderLookup from "@/library/BankProviderLookup";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
const atLeastOneProvider = (value) => value.length > 0;
const atLeastOnePaymentOption = (value) => value.length > 0;
import TriggerActionLookup from "@/library/TriggerActionLookup";
import CampaignLookup from "@/library/CampaignLookup";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    VipCriteriaList,
    ClaimTypeLookup,
    PromotionType,
    PromotionGroupLookup,
    BankProviderLookup,


    TriggerActionLookup,
    CampaignLookup,
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      event_type: "",
      action_type: "",
      reward: "",
      threshold: "",
      campaign_id: "",
      msg_greeting: false,
      msg_title: "",
      msg_body: "",
      claim_type: "",
      min_deposit: "",
      bonus_rate: "",
      max_bonus: 0,
      rollover: "",
      criteria: "",
      withhold_bonus: false,
      withhold_amount: 0,
      max_withdraw_amount: 0,
      start_date: this.$moment(new Date).format('YYYY-MM-DD'),
      end_date: this.$moment(new Date).format('YYYY-MM-DD'),
      start_time: "00:00:00",
      end_time: "23:59:59",
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
      sunday: true,
      claim_limit: 0,
      claim_limit_daily: 0,
      max_withdraw_multiple: 0,
      provider_list: [],
      providerList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      localeDate: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      localeTime: {
        format: "HH:mm:ss",
        useCurrent: true
      },
      hideOpt: ['DEPOSIT'],
      // payment_option_list: [],
      paymentOptionList: [],
      allSelectedPO: true,
      allSelectedPG: true,
      // payment_gateway_list: [],
      paymentGatewayList: [],
      formBonusRate: {},
      settingList: [],
      allSelected: {},
      providerCatList: [],
      prefixMap: {},
      pList: [],
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    rowsPList() {
      const rows = [];
      for (let i = 0; i < this.pList.length; i += 3) {
        rows.push(this.pList.slice(i, i + 3));
      }
      return rows;
    },
  },
  validations() {
    const formBonusRateValidations = {};
    for (let i = 1; i <= Number(this.claim_limit); i++) {
      // formBonusRateValidations[`bonus_rate_${i}`] = { required,decimal };
      formBonusRateValidations[`bonus_rate_${i}`] = { 
        required : requiredIf(function () {
          return ['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(this.claim_type);
        }),
        decimal
      };
    }
    return {
      event_type: {
        required
      },
      action_type: {
        required
      },
      msg_title: {
        required
      },
      msg_body: {
        required
      },
      reward: {
        required: requiredIf(function () {
          return ['FREESPIN', 'INBOX'].includes(this.action_type);
        }),
        decimal: requiredIf(function () {
          return ['INBOX'].includes(this.action_type);
        }),
        minValue: function (value) {
          if (!['INBOX'].includes(this.action_type)) return true
          return minValue(0)(value)
        }
      },
      threshold: {
        required: requiredIf(function () {
          return ['IDLE_USER', 'PREDICT_CHURN', 'WITHDRAWAL'].includes(this.event_type);
        }),
        integer
      },
      campaign_id: {
        required: requiredIf(function () {
          return ['INBOX'].includes(this.action_type) || ['PREDICT_CHURN'].includes(this.event_type);
        })
      },
      formBonusRate: formBonusRateValidations,
      claim_type: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      min_deposit: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        }),
        decimal,
        // minValue: minValue(100)
        minValue(value) {
          if (['CUSTOM_PROMO'].includes(this.action_type)) {
            return minValue(this.getMinDeposit())(value)
          } else {
            return true
          }
        },
      },
      bonus_rate: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        }),
        decimal
      },
      max_bonus: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        }),
        decimal
      },
      rollover: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        }),
        integer,
        minValue(value) {
          if (['CUSTOM_PROMO'].includes(this.action_type)) {
            return minValue(1)(value)
          } else {
            return true
          }
        },
        // minValue: minValue(1)
      },
      criteria: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      withhold_bonus: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      withhold_amount: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        }),
        decimal
      },
      max_withdraw_amount: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        }),
        decimal
      },
      start_date: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      end_date: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      start_time: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      end_time: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      monday: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      tuesday: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      wednesday: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      thursday: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      friday: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      saturday: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      sunday: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      claim_limit: {
        integer,
        minValue(value) {
          if (['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(this.claim_type) && ['CUSTOM_PROMO'].includes(this.action_type)) {
            return minValue(1)(value)
          } else {
            return true
          }
        },
        maxValue(value) {
          if (['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(this.claim_type) && ['CUSTOM_PROMO'].includes(this.action_type)) {
            return maxValue(10)(value)
          } else {
            return true
          }
        },
        required: requiredIf(function () {
          return ['ALL DAY','NEWBIE','ONCE'].includes(this.claim_type) && ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      claim_limit_daily: {
        integer,
        required: requiredIf(function () {
          return ['ALL DAY','NEWBIE','ONCE'].includes(this.claim_type) && ['CUSTOM_PROMO'].includes(this.action_type);
        })
      },
      max_withdraw_multiple: {
        required: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        }),
        integer
      },
      provider_list: {
        atLeastOneProvider: requiredIf(function () {
          return ['CUSTOM_PROMO'].includes(this.action_type);
        }),
        minLength: minLength(1)
      },
      // payment_option_list: {
      //   atLeastOnePaymentOption,
      //   minLength: minLength(1)
      // },
      // payment_gateway_list: {
      //   atLeastOnePaymentGateway,
      //   minLength: minLength(1)
      // },
    }
  },
  watch : {
    provider_list: {
      handler(newValue) {
        const val = (newValue.length === this.pList.length && this.pList.length > 0)

        const checkGroupSelected = prefix => {
          const items = this.pList.filter(item => item.category === prefix)
          return items.length > 0 && items.every(item => newValue.includes(item.value))
        }

        Object.keys(this.allSelected).forEach(k => {
          const num = Number(k)

          // master
          if (num === 0) {
            this.$set(this.allSelected, 0, val)
          }
          // others
          else {
            this.$set(this.allSelected, num, checkGroupSelected(this.providerCatList[num-1]))
          }
        })
      },
      deep: true
    },
    // payment_option_list(newValue) {
    //   if (newValue.length === 0)
    //     this.allSelectedPO = false;
    //   else if (newValue.length === this.paymentOptionList.length)
    //     this.allSelectedPO = true;
    //   else
    //     this.allSelectedPO = false;
    // },
    // payment_gateway_list(newValue, oldValue) {
    //   if (newValue.length === 0)
    //     this.allSelectedPG = false;
    //   else if (newValue.length === this.paymentGatewayList.length)
    //     this.allSelectedPG = true;
    //   else
    //     this.allSelectedPG = false;
    // },
    withhold_bonus(newVal) {
      if(newVal)
        this.withhold_amount = 0
    },
    claim_type(newVal) {
      if(['ALL DAY','NEWBIE','ONCE','DAILY FIRST DEPOSIT'].includes(newVal)) {
        this.claim_limit = 0
        this.claim_limit_daily = 0
      }

      if(['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(newVal))
        this.bonus_rate = 0
    },
  },
  methods: {
    inputMaxWithdraw: function(input, type) {
      if(input > 0) {
        this['max_withdraw_' + type] = 0;
      }
    },
    onClickEsc: function(bvModalEvent) {
      if (bvModalEvent.trigger === 'esc') {
        this.cancelStatus()
      }
    },
    cancelStatus: function() {
      this.$emit("cancelStatus");
    },
    getMinDeposit: function() {
      for(var i = 0; i < this.settingList.length; i++) {
        if(this.settingList[i].setting_key == 'min_deposit') {
          return this.settingList[i].setting_value;
        }
      }

      return 100
    },
    getOperatorSettingList: function() {
      let url = config.operatorSettingListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.settingList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getPaymentOptionList: function() {
      // this.selectedFunctions = [];
      let url = config.paymentOptionListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = response.data.dt;
                if (list.length > 0) {
                  let result = list
                    .filter(item => item.payment_mode.toUpperCase() !== "MANUAL" && item.status == true) // Exclude "MANUAL"
                    .map(item => ({
                      value: item.payment_mode.toUpperCase(),
                      text: item.payment_desc,
                      checked: true
                    }));

                  this.paymentOptionList = result;
                } else {
                  this.paymentOptionList = [];
                }
                this.payment_option_list = this.paymentOptionList.map(p => p.value);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getPaymentProviderList: function() {
      let url = config.paymentProviderGbListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = response.data.dt;
                if(list.length > 0){
                  let result = [];
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].provider_code.toUpperCase(), text: list[i].provider_code.toUpperCase(), checked: false});
                  }
                  this.paymentGatewayList = result;
                } else {
                  this.paymentGatewayList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    selectAll: function(mode, evt) {
      const prefixMap = this.prefixMap

      // If mode is 0 (master checkbox toggled), sync all individual selections
      if (mode === 0) {
        Object.keys(this.allSelected).forEach(k => {
          this.$set(this.allSelected, k, evt.target.checked)
        })

        if (!this.allSelected[0]) {
          this.provider_list = [];
          return; // Exit early if unchecking all
        }

        // Select all providers with matching prefixes
        const allPrefixes = Object.values(prefixMap);
        this.provider_list = this.pList
          .filter(item => allPrefixes.some(prefix => item.category == prefix))
          .map(item => item.value);

        return;
      }

      const checked = evt.target.checked
      this.$set(this.allSelected, mode, checked)

      // Individual group checkbox toggled
      const prefix = prefixMap[mode];
      const groupItems = this.pList.filter(item => item.category == prefix);
      const groupValues = groupItems.map(item => item.value);

      if (this.allSelected[mode]) {
        // Add group values to provider_list without duplicates
        this.provider_list = Array.from(new Set([...this.provider_list, ...groupValues]));
      } else {
        // Remove only group values
        this.provider_list = this.provider_list.filter(val => !groupValues.includes(val));
      }
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (this.$v.$invalid) return

      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_trigger_status_confirm", { name: this.event_type }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.callUpdate();
          }
        });
    },
    callUpdate() {
      let url = config.triggerOpStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        event_type: this.event_type,
        action_type: this.action_type,
        new_status: true,
        msg_greeting: this.msg_greeting,
        msg_title: this.msg_title,
        msg_body: this.msg_body
      };

      if(['CUSTOM_PROMO'].includes(this.action_type)) {
        if (this.withhold_bonus && parseFloat(this.withhold_amount) > 0) {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.withtholdBonusAndAmountGreaterThanZero"), "error");
          return;
        }

        if (parseFloat(this.max_withdraw_amount) > 0 && parseFloat(this.max_withdraw_multiple) > 0) {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.maxWithdrawMultipleAndAmountGreaterThanZero"), "error");
          return;
        }

        json.claim_type = this.claim_type
        json.min_deposit = this.min_deposit
        json.bonus_rate = this.bonus_rate
        json.max_bonus = this.max_bonus
        json.rollover = this.rollover
        json.criteria = this.criteria
        json.withhold_bonus = this.withhold_bonus
        json.withhold_amount = this.withhold_amount
        json.max_withdraw_amount = this.max_withdraw_amount
        json.start_date = this.start_date
        json.end_date = this.end_date
        json.start_time = this.start_time
        json.end_time = this.end_time
        json.monday = this.monday
        json.tuesday = this.tuesday
        json.wednesday = this.wednesday
        json.thursday = this.thursday
        json.friday = this.friday
        json.saturday = this.saturday
        json.sunday = this.sunday
        json.claim_limit = ['DAILY'].includes(this.claim_type) ? this.claim_limit_daily : this.claim_limit
        json.max_withdraw_multiple = this.max_withdraw_multiple
        json.payment_option_list = null

        for(var i = 1; i <= this.claim_limit; i++) {
          json["bonus_rate_" + i] = this.formBonusRate['bonus_rate_' + i]
        }

        if (this.provider_list.length != this.providerList.length)
          json.provider_list = this.removeDuplicate(this.provider_list.sort()).toString();
      }

      if(['FREESPIN', 'INBOX'].includes(this.action_type)) {
        json.reward = this.reward
      }

      if(['IDLE_USER', 'PREDICT_CHURN', 'WITHDRAWAL'].includes(this.event_type)) {
        json.threshold = this.threshold
      }

      if(['INBOX'].includes(this.action_type) || ['PREDICT_CHURN'].includes(this.event_type)) {
        json.campaign_id = this.campaign_id
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.editTriggerStatus.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_trigger_status", this.feedback.status);
                this.$refs.editTriggerStatus.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getPList() {
      let list = this.providerList;

      let result = [];

      for(var i = 0; i < list.length; i++) {
        result.push({value: list[i].provider_code, text: list[i].provider_name, checked: false, category: list[i].category});
      }
      this.pList = result;

      this.initialProviderCheckbox();
    },
    getProviderList: function() {
      let url = config.providerMaintenanceOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        is_free: false,
        credit_type: "SEAMLESS"
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = (response.data.dt || []).filter(item => item.aggregator !== "GTA");
                if(list.length > 0){
                  this.providerList = (response.data.dt || []).filter(item => item.aggregator !== "GTA");
                  this.setCategory();
                  this.getPList();
                } else {
                  this.providerList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setCategory() {
      // Build unique category list using Set (avoid duplicates)
      const catsSet = new Set()
      for (const item of this.providerList) {
        // add each category into Set (Set auto removes duplicates)
        catsSet.add(item.category)
      }

      // convert Set back to Array so we can use v-for easily
      this.providerCatList = Array.from(catsSet)

      // create checkbox state object
      // key 0 = master "select all" checkbox (initially false = unchecked)
      const obj = { 0: false }

      // for each category index, set initial checkbox state for that group also false
      this.providerCatList.forEach((_, i) => {
        obj[i + 1] = false  // i+1 means group number starting from 1
      })

      this.allSelected = obj

      this.prefixMap = this.providerCatList.reduce((o, v, idx) => {
        o[idx + 1] = v
        return o
      }, {})
    },
    initialProviderCheckbox() {
      if (this.item.provider_list != null) {
        var arr = this.item.provider_list.split(',');
        // Get all valid provider codes from pList
        const validProviderCodes = this.pList.map(p => p.value);

        for(var i = 0; i < arr.length; i++) {
          // Only add provider codes that exist in the current pList
          if (validProviderCodes.includes(arr[i])) {
            this.provider_list.push(arr[i]);
          }
        }
      }
      else {
        this.allSelected[0] = true;
        var arr = this.pList;
        for(var i = 0; i < arr.length; i++) {
          this.provider_list.push(arr[i].value);
        }
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.event_type = "";
    },
    shown: function() {
      this.$v.$reset();
      this.getOperatorSettingList();
      this.event_type = this.item.event_type;
      this.action_type = this.item.action_type;
      this.reward = this.item.reward;
      this.threshold = this.item.threshold;
      this.campaign_id = this.item.campaign_id;
      this.msg_greeting = this.item.msg_greeting;
      this.msg_title = this.item.msg_title;
      this.msg_body = this.item.msg_body;
      this.claim_type = this.item.claim_type;
      this.min_deposit = this.item.min_deposit;
      this.bonus_rate = this.item.bonus_rate;
      this.max_bonus = this.item.max_bonus != null ? this.item.max_bonus : 0;;
      this.bonus_amount = this.item.bonus_amount;
      this.rollover = this.item.rollover;
      this.criteria = this.item.criteria;
      this.withhold_bonus = this.item.withhold_bonus;
      this.withhold_amount = this.item.withhold_amount != null ? this.item.withhold_amount : 0;
      this.max_withdraw_amount = this.item.max_withdraw_amount != null ? this.item.max_withdraw_amount : 0;
      this.start_time = this.item.start_time;
      this.end_time = this.item.end_time;
      this.monday = this.item.monday;
      this.tuesday = this.item.tuesday;
      this.wednesday = this.item.wednesday;
      this.thursday = this.item.thursday;
      this.friday = this.item.friday;
      this.saturday = this.item.saturday;
      this.sunday = this.item.sunday;
      if(this.item.start_date != null) this.$moment(this.item.start_date).format('YYYY-MM-DD');
      else this.start_date = this.$moment(new Date()).format('YYYY-MM-DD');
      if(this.item.end_date != null) this.$moment(this.item.end_date).format('YYYY-MM-DD');
      else this.end_date = this.$moment(new Date()).format('YYYY-MM-DD');
      if(this.start_time == null) this.start_time = "00:00:00";
      if(this.end_time == null) this.end_time = "23:59:59";
      if(this.msg_greeting == null) this.msg_greeting = false
      if(this.criteria == null) this.criteria = ''
      if(this.claim_type == null) this.claim_type = ''
      if(this.campaign_id == null) this.campaign_id = ''
      if(this.withhold_bonus == null) this.withhold_bonus = false
      if(this.monday == null) this.monday = false
      if(this.tuesday == null) this.tuesday = false
      if(this.wednesday == null) this.wednesday = false
      if(this.thursday == null) this.thursday = false
      if(this.friday == null) this.friday = false
      if(this.saturday == null) this.saturday = false
      if(this.sunday == null) this.sunday = false

      this.claim_limit = this.item.claim_limit
      if(this.claim_limit == null) this.claim_limit = 0
      this.max_withdraw_multiple = this.item.max_withdraw_multiple != null ? this.item.max_withdraw_multiple : 0;;
      // this.payment_option_list = [];
      // this.payment_gateway_list = [];
      const bonusRate = {};
      for(var x = 1; x <= this.claim_limit; x++) {
        this.$set(bonusRate, `bonus_rate_${x}`, this.item['bonus_rate_' + x]);
      }
      this.formBonusRate = bonusRate;
      this.paymentGatewayList = [];
      this.provider_list = []
      this.providerList = []
      this.allSelected = {};
      this.providerCatList = [];
      this.prefixMap = {};
      this.pList = []
      if(this.event_type == 'PREDICT_CHURN') this.action_type =  'DEPOSIT_TIER'
      this.getProviderList();
    }
  },
};
</script>
